import * as React from "react";
const SvgAddIcon = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0.25 0.28 15.69 15.48", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.95 15.76H10.21V10.09H15.94V5.95H10.21V0.28H5.95V5.95H0.25V10.09H5.95V15.76Z", fill: "black" }));
export default SvgAddIcon;
